import { useEffect, useState, useCallback } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plug, GitMerge, RefreshCw, ScrollText } from "lucide-react";
import { OrbitPageHeader, OrbitStatus } from "@/components/orbit";
import ConnectionTab from "./ConnectionTab";
import MappingTab from "./MappingTab";
import SyncTab from "./SyncTab";
import LogsTab from "./LogsTab";
import ProductsTab from "./ProductsTab";
import SalesTab from "./SalesTab";
import AuditTab from "./AuditTab";
import Lot3Tab from "./Lot3Tab";
import Lot3ATab from "./Lot3ATab";
import Lot3BTab from "./Lot3BTab";
import Lot3CTab from "./Lot3CTab";
import Lot4ATab from "./Lot4ATab";
import Lot4BTab from "./Lot4BTab";
import Lot4CTab from "./Lot4CTab";
import Lot4DTab, { Lot6Panel } from "./Lot4DTab";
import { Package, ShoppingCart, ClipboardList, Trash2 } from "lucide-react";

const TABS = [["connexion", "Connexion", Plug], ["mapping", "Mapping", GitMerge], ["produits", "Produits", Package], ["ventes", "Ventes", ShoppingCart], ["audit", "Audit Lot 2", ClipboardList], ["lot3", "Audit Lot 3", ClipboardList], ["lot3a", "Référentiels 3A", ClipboardList], ["lot3b", "Données métier", ClipboardList], ["lot3c", "Pertes 3C", ClipboardList], ["lot4a", "Migration Produit 4A", ClipboardList], ["lot4b", "Bascule 4B", ClipboardList], ["lot4c", "Food Cost 4C", ClipboardList], ["lot4d", "Recettes 4D", ClipboardList], ["lot6", "Production & pertes", Trash2], ["sync", "Synchronisation", RefreshCw], ["logs", "Logs", ScrollText]];
const ST = { connected: ["Connecté", "green"], error: ["Erreur", "red"], not_configured: ["Non configuré", "muted"], unknown: ["À tester", "amber"] };

export default function InpulsePage() {
  const [sp, setSp] = useSearchParams(); const nav = useNavigate();
  const tab = sp.get("tab") || "connexion";
  const [status, setStatus] = useState(null);
  const reload = useCallback(() => api.get("/integrations/inpulse/status").then(r => setStatus(r.data)).catch(e => toast.error(e.response?.data?.detail || "Statut indisponible")), []);
  useEffect(() => { reload(); }, [reload]);
  const [sl, sc] = ST[status?.status] || ST.unknown;
  return (
    <div className="orbit-v2 space-y-5" data-testid="inpulse-page">
      <OrbitPageHeader kicker="Administration · Intégrations" title="Inpulse" description="Connecteur, référentiel réseau et mapping des points de vente Inpulse vers Orbit."
        actions={<><OrbitStatus label={sl} color={sc} testid="inpulse-global-status" /><button className="o-btn o-btn-secondary" onClick={() => nav("/admin")} data-testid="inpulse-back">Administration</button></>} testid="inpulse-header" />
      <nav className="o-nav" data-testid="inpulse-nav">
        {TABS.map(([k, l, I]) => <button key={k} className="o-nav-item" aria-current={tab === k ? "page" : undefined} onClick={() => setSp({ tab: k })} data-testid={`inpulse-tab-${k}`}><I className="w-3.5 h-3.5" strokeWidth={1.75} />{l}</button>)}
      </nav>
      {tab === "connexion" && <ConnectionTab status={status} reload={reload} />}
      {tab === "mapping" && <MappingTab />}
      {tab === "produits" && <ProductsTab status={status} />}
      {tab === "ventes" && <SalesTab status={status} />}
      {tab === "audit" && <AuditTab status={status} />}
      {tab === "lot3" && <Lot3Tab status={status} />}
      {tab === "lot3a" && <Lot3ATab status={status} />}
      {tab === "lot3b" && <Lot3BTab status={status} />}
      {tab === "lot3c" && <Lot3CTab status={status} />}
      {tab === "lot4a" && <Lot4ATab status={status} />}
      {tab === "lot4b" && <Lot4BTab status={status} />}
      {tab === "lot4c" && <Lot4CTab status={status} />}
      {tab === "lot4d" && <Lot4DTab status={status} />}
      {tab === "lot6" && <div className="space-y-3" data-testid="lot6-tab"><h2 className="font-bold">Lot 6 — Production & pertes Inpulse</h2><div className="o-muted text-[12px]">Synchronise les pertes Inpulse (lecture seule, worker, checkpoint mensuel) vers l'agrégat jour × magasin × produit utilisé par Analyse Produit, Produit 360 et Pilotage Production. Aucune écriture Inpulse.</div><Lot6Panel locked={!status?.configured} /></div>}
      {tab === "sync" && <SyncTab status={status} reload={reload} />}
      {tab === "logs" && <LogsTab />}
    </div>
  );
}
